<!-- Navbar -->
<div class="page-content">
  <div class="page-header">
    <app-navbar></app-navbar>
  </div>

  <!-- Content Section -->
  <div class="page-body" [class.collapsed]="isCollapsed" [class.open-sidebar]="openSidebar" [class.animate-sidebar]="isAnimating">
    <div class="sidebar" [class.collapsed]="isCollapsed">
      <app-sidebar (toggleCollapse)="onToggleCollapse()" [isCollapseSidebar]="isCollapsed || isCompact" [isCompact]="isCompact"
        [closeSidebar]="sidebarToggleClose.bind(this)"></app-sidebar>
    </div>

    <div class="main-content" [class.collapsed]="isCollapsed">
      <router-outlet></router-outlet>
    </div>
    <div class="overlay-body" (click)="sidebarToggleClose()"></div>
  </div>
</div>
<!-- scripts -->